import LiveCard from './LiveCard.vue';
export default {
  name: 'Live',
  components: {
    LiveCard
  },
  props: {
    liveList: {
      type: Array
    },
    // 导航是否打开
    bannerOpen: {
      type: Boolean,
      default: true
    }
  },

  created() {
    this.getNavList();
  },

  data() {
    return {
      menu: null
    };
  },

  methods: {
    async getNavList() {
      const res = await this.$http.getNavList();
      this.menu = res.find(item => item.menu_code == '10601'); // console.log('menu', this.menu);
    }

  }
};